var jade = require("/home/romain/Cozy/cozy-proxy/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (figureid, id, link, next, public_name, t) {
buf.push("<div class=\"main-wrapper\"><header>");
if ( figureid)
{
buf.push("<figure" + (jade.attr("id", id, true, true)) + ">");
if ( link)
{
buf.push("<a" + (jade.attr("href", link, true, true)) + " target=\"_blank\"><svg><use" + (jade.attr("xlink:href", figureid, true, true)) + "></use></svg></a>");
}
else
{
buf.push("<div class=\"svg-wrapper\"><svg><use" + (jade.attr("xlink:href", figureid, true, true)) + "></use></svg></div>");
}
buf.push("</figure>");
}
if ( public_name)
{
buf.push("<h1>" + (jade.escape(null == (jade_interp = t('step welcome user', {name: public_name})) ? "" : jade_interp)) + "</h1>");
}
else
{
buf.push("<h1>" + (jade.escape(null == (jade_interp = t('step welcome anon')) ? "" : jade_interp)) + "</h1>");
}
buf.push("</header><div role=\"region\"><p>" + (jade.escape(null == (jade_interp = t('step welcome congrats')) ? "" : jade_interp)) + "</p></div><footer><div class=\"controls\"><a" + (jade.attr("href", next, true, true)) + " role=\"button\" class=\"next\">" + (jade.escape(null == (jade_interp = t('step welcome next')) ? "" : jade_interp)) + "</a></div><div class=\"progression\"></div></footer></div>");}.call(this,"figureid" in locals_for_with?locals_for_with.figureid:typeof figureid!=="undefined"?figureid:undefined,"id" in locals_for_with?locals_for_with.id:typeof id!=="undefined"?id:undefined,"link" in locals_for_with?locals_for_with.link:typeof link!=="undefined"?link:undefined,"next" in locals_for_with?locals_for_with.next:typeof next!=="undefined"?next:undefined,"public_name" in locals_for_with?locals_for_with.public_name:typeof public_name!=="undefined"?public_name:undefined,"t" in locals_for_with?locals_for_with.t:typeof t!=="undefined"?t:undefined));;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/views/templates/view_steps_welcome.jade
// module id = 25
// module chunks = 0